import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import ENV from 'bullitt-time-cloud-live/config/environment';

export default class RequestCodeController extends Controller {
	@tracked firstName = '';
	@tracked lastName = '';
	@tracked email = '';
	@tracked isSubmitting = false;
	@tracked errorMessage = null;
	@tracked successMessage = null;

	get isFormValid() {
		return this.firstName.trim() && this.lastName.trim() && this.email.trim() && this.isValidEmail;
	}

	get isValidEmail() {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(this.email.trim());
	}

	@action
	updateFirstName(event) {
		this.firstName = event.target.value;
		this.errorMessage = null;
	}

	@action
	updateLastName(event) {
		this.lastName = event.target.value;
		this.errorMessage = null;
	}

	@action
	updateEmail(event) {
		this.email = event.target.value;
		this.errorMessage = null;
	}

	@action
	async submitRequest(event) {
		event.preventDefault();

		if (!this.isFormValid) {
			if (!this.firstName.trim() || !this.lastName.trim()) {
				this.errorMessage = 'Please enter your first and last name';
			} else if (!this.isValidEmail) {
				this.errorMessage = 'Please enter a valid email address';
			}
			return;
		}

		this.isSubmitting = true;
		this.errorMessage = null;
		this.successMessage = null;

		try {
			const response = await fetch(`${ENV.APP.CLOUD_REST_API_ENDPOINT}/access-requests`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					firstName: this.firstName.trim(),
					lastName: this.lastName.trim(),
					email: this.email.trim()
				})
			});

			const data = await response.json();

			if (response.ok) {
				this.successMessage = 'Your request has been submitted! You will receive an email when your access code is ready.';
				this.firstName = '';
				this.lastName = '';
				this.email = '';
			} else {
				this.errorMessage = data.error || 'Failed to submit request. Please try again.';
			}
		} catch (error) {
			console.error('[RequestCode] Error:', error);
			this.errorMessage = 'An error occurred. Please try again.';
		} finally {
			this.isSubmitting = false;
		}
	}
}
